import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { dataFileUrl, saveFileUrl } from '../../common/api';
import ActionButtons from '../../common/ActionButtons';
import { Icon } from '../../common/AppShell';
import Loader from '../../common/Loader/Loader';
import Switch from '../Switch/Switch';

const Available = () => {
  const navigate = useNavigate();
  const [data, setData] = useState({ isNotAvailable: false, content: '' });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${dataFileUrl('available')}?t=${Date.now()}`)
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        toast.error('Ошибка загрузки данных.');
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const saveData = () => {
    axios
      .put(saveFileUrl('available'), data)
      .then(() => toast.success('Данные успешно обновлены!'))
      .catch((error) => {
        console.error('Error saving data:', error);
        toast.error('Ошибка обновления данных.');
      });
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <section className="screen-stack">
      <div className="form-card">
        <div className="form-card-title">
          <Icon name="health_and_safety" />
          <div>
            <h2>Доступность сайта</h2>
            <p>Управление заглушкой сайта</p>
          </div>
        </div>

        <div className="setting-row">
          <div>
            <strong>{data.isNotAvailable ? 'Сайт недоступен' : 'Сайт доступен'}</strong>
            <span>{data.isNotAvailable ? 'Посетители увидят заглушку' : 'Посетители видят сайт'}</span>
          </div>
          <Switch
            value={data.isNotAvailable}
            onColor="#4DD863"
            handleToggle={() =>
              handleChange({
                target: {
                  name: 'isNotAvailable',
                  type: 'checkbox',
                  checked: !data.isNotAvailable,
                },
              })
            }
          />
        </div>

        <label className={`app-field ${data.isNotAvailable ? '' : 'muted'}`}>
          <span>Почему сайт недоступен</span>
          <textarea
            name="content"
            disabled={!data.isNotAvailable}
            placeholder="Введите причину недоступности сайта"
            onChange={handleChange}
            value={data.content || ''}
            rows="3"
          />
        </label>
      </div>

      <ActionButtons onBack={() => navigate('/more')} onSave={saveData} />
    </section>
  );
};

export default Available;
